// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"853":"243d0b73","2081":"6ebc13c2","2496":"636fd893","2565":"3b74ed63","3459":"8cf2d008","8655":"c9c9dc57","9303":"c062a81b"}[chunkId] + ".chunk.css";
};